import React, { useEffect, useState } from "react";
import MiddleCompCr from "./MiddleCompCR";
import ClassRecording from "./ClassRecording";
import LeftCompoCr from "./LeftCompoCr";
import { Snackbar } from "@mui/material";
import StoryNavigation from "./StoryNavigation";
import AudioSection from "./AudioSection";

const StoryReading = ({
  selectedTextbook,
  wsRef,
  unifiedSession,
  selectedStudent,
  socketres,
  setSocketres,
  setLoading,
  loading,
  apiResponseMiddle,
  apiFlag,
  setApiFlag,
  stories,
  setStoryId,
  storyId,
  studentflag,
  students,
  speecherror,
  readingContentError,
  setReadingContentError,
  creditsRemaining = 0,
  refreshCredits,
  showRecordingCountdown,
}) => {
  if (process.env.NODE_ENV !== "production") {
    console.debug("StoryReading: received creditsRemaining:", creditsRemaining);
    console.debug("StoryReading: unifiedSession:", unifiedSession);
  }

  const [currentStoryIndex, setCurrentStoryIndex] = useState(0);
  const [lastActiveIndex, setLastActiveIndex] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isRecordClicked, setIsRecordClicked] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [snackbarReadingContentOpen, setSnackbarReadingContentOpen] =
    useState(false);
  const [audioCurrentTime, setAudioCurrentTime] = useState(0);
  const [activeWordIndex, setActiveWordIndex] = useState(-1);
  console.log("showRecordingCountdown in story reading : ",showRecordingCountdown)
  // Determine the current content based on the type (textbook or story passage)
  const currentContent = stories?.length
    ? stories[currentStoryIndex]
    : selectedTextbook;

  // Extract expert audio URL from multiple possible sources
  const expertAudioUrl =
    (stories && stories[currentStoryIndex]?.expert_audio) ||
    selectedTextbook?.expert_audio ||
    (students && students[0]?.expert_audio);

  console.log("expertAudioUrl", expertAudioUrl);

  const effectiveSessionId = unifiedSession.id;

  console.log("StoryReading: Effective session ID:", effectiveSessionId, {
    unifiedSession,
  });

  useEffect(() => {
  const timedWords =
    stories?.[currentStoryIndex]?.expert_audios?.[0]
      ?.timed_transcript?.words;

  if (!timedWords?.length) {
    setActiveWordIndex(-1);
    return;
  }

  const currentWord = timedWords.find(
    (w) =>
      audioCurrentTime >= w.start &&
      audioCurrentTime < w.end
  );

  if (currentWord) {
    setActiveWordIndex(currentWord.index);
  } else {
    setActiveWordIndex(-1);
  }
}, [audioCurrentTime, stories, currentStoryIndex]);

  useEffect(() => {
    setSocketres(null);
  }, [selectedTextbook, setSocketres, studentflag, currentStoryIndex]);

  useEffect(() => {
    if (stories?.length) {
      setStoryId(stories[currentStoryIndex].id);
    }
  }, [currentStoryIndex, stories, setStoryId]);

  useEffect(() => {
    if (!loading) {
      setCurrentStoryIndex(lastActiveIndex);
    }
  }, [loading, lastActiveIndex]);

  useEffect(() => {
    if (speecherror) {
      setSnackbarOpen(true);
    }
  }, [speecherror]);

  // When a successful submission is received via WebSocket, refresh credit totals
  useEffect(() => {
    if (socketres && typeof refreshCredits === "function") {
      // call refreshCredits to reflect server-side decrement
      refreshCredits().catch((e) =>
        console.warn("Error refreshing credits:", e),
      );
    }
  }, [socketres, refreshCredits]);

  useEffect(() => {
    if (readingContentError) {
      setSnackbarReadingContentOpen(true);
    }
  }, [readingContentError]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleReadingContentSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarReadingContentOpen(false);
    setReadingContentError(false);
  };

  return (
    <div className="w-full flex flex-col gap-6 h-full">
      <div className="flex flex-col gap-6">
        <MiddleCompCr
          selectedTextbook={selectedTextbook}
          socketres={socketres}
          stories={stories}
          currentStoryIndex={currentStoryIndex}
          students={students}
          selectedStudent={selectedStudent}
          activeWordIndex={activeWordIndex}
          loading={loading}
          wsRef={wsRef}
          isRecordClicked={isRecordClicked} // Pass the new state
          access_token={unifiedSession?.access_token}
          sessionId={unifiedSession?.id}
        />

        {/* Place StoryNavigation and ClassRecording in the same row */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="w-full md:w-auto">
            <StoryNavigation
              stories={stories}
              loading={loading}
              currentStoryIndex={currentStoryIndex}
              setCurrentStoryIndex={setCurrentStoryIndex}
              setLastActiveIndex={setLastActiveIndex}
              setSocketres={setSocketres}
              isRecording={isRecording}
            />
          </div>

          <div className="w-full md:w-auto">
            <ClassRecording
              wsRef={wsRef}
              unifiedSession={unifiedSession}
              selectedTextbook={selectedTextbook}
              selectedStudent={selectedStudent}
              setLoading={setLoading}
              apiFlag={apiFlag}
              setApiFlag={setApiFlag}
              setSocketres={setSocketres}
              sessionId={effectiveSessionId}
              storyId={storyId}
              currentStoryIndex={currentStoryIndex}
              setLastActiveIndex={setLastActiveIndex}
              students={students}
              socketres={socketres}
              setIsRecordClicked={setIsRecordClicked}
              setIsRecording={setIsRecording}
              isRecording={isRecording}
              creditsRemaining={creditsRemaining}
              refreshCredits={refreshCredits}
              showRecordingCountdown={showRecordingCountdown}
            />
          </div>
        </div>
      </div>

      {/* Updated layout with audio section and score section */}
      <div className="flex flex-col md:flex-row gap-4">
        <div className="w-full md:w-1/2">
          <AudioSection
            setAudioCurrentTime={setAudioCurrentTime}
            storyId={storyId}
            expertAudioUrl={expertAudioUrl}
            socketres={socketres}
            unifiedSession={unifiedSession}
            students={students}
            selectedStudent={selectedStudent}
          />
        </div>
        <div className="w-full md:w-1/2">
          <LeftCompoCr
            socketres={socketres}
            apiResponseMiddle={apiResponseMiddle}
            apiFlag={apiFlag}
            unifiedSession={unifiedSession}
            selectedStudent={selectedStudent}
            students={students}
            passageId={storyId || selectedTextbook?.id}
            alreadyChecked={
              // Use per-passage property checkedPassages for accurate per-passage checking
              students
                ? students
                    .filter((s) => {
                      // checkedPassages should be an array of passage IDs the student has completed
                      return (
                        Array.isArray(s.checkedPassages) &&
                        s.checkedPassages.includes(
                          storyId || selectedTextbook?.id,
                        )
                      );
                    })
                    .map((s) => {
                      // If you have per-passage scores, use s.scores[passageId]
                      const passageKey = storyId || selectedTextbook?.id;
                      const passageScore = s.scores?.[passageKey];
                      return {
                        studentId: s.id,
                        passageId: passageKey,
                        celebrated: passageScore === 100,
                        scored: passageScore > 0 && passageScore < 100,
                      };
                    })
                : []
            }
          />
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="No speech detected in recording please try again"
      />

      <Snackbar
        open={snackbarReadingContentOpen}
        autoHideDuration={6000}
        onClose={handleReadingContentSnackbarClose}
        message="Error occurred while processing reading content"
      />
    </div>
  );
};

export default StoryReading;
